import { useState } from 'react';
import styles from './AiRecommendations.module.css';
import { colorForCriterion, contribution } from './recommendationModel';

/**
 * 기준별 몫을 이어 붙인 가로 막대. 막대 전체 길이가 100점이고, 칠해진 길이의 합이 총점이다.
 * 칸에 마우스를 올리면 기준 이름 · 점수(1~5) · 가중치를 보여준다.
 */
export default function ScoreBar({ criteria, scores }) {
  const [hover, setHover] = useState(null); // { index, left }

  const segments = criteria.map((c, i) => {
    const score = scores?.[c.id];
    return { criterion: c, index: i, score, width: contribution(score, c.weight) };
  });
  const judged = segments.some(s => s.score != null);
  const summary = segments
    .map(s => `${s.criterion.label} ${s.score != null ? s.score.toFixed(1) : '-'}점(가중치 ${s.criterion.weight}%)`)
    .join(', ');

  if (!judged) {
    return <div className={styles.barEmpty}>사진 평가 없음</div>;
  }

  let offset = 0;
  const active = hover != null ? segments[hover.index] : null;

  return (
    <div className={styles.barWrap}>
      <div className={styles.barTrack} role="img" aria-label={summary}>
        {segments.map(s => {
          const left = offset;
          offset += s.width;
          return (
            <span
              key={s.criterion.id}
              className={styles.barSegment}
              style={{ width: `${s.width}%`, background: colorForCriterion(s.index), opacity: hover && hover.index !== s.index ? 0.45 : 1 }}
              onMouseEnter={() => setHover({ index: s.index, left: left + s.width / 2 })}
              onMouseLeave={() => setHover(null)}
            />
          );
        })}
      </div>
      {active && (
        <div className={styles.barTooltip} style={{ left: `${Math.min(85, Math.max(15, hover.left))}%` }} role="tooltip">
          <span className={styles.legendSwatch} style={{ background: colorForCriterion(active.index) }} aria-hidden="true" />
          <strong>{active.criterion.label}</strong>
          <span>{active.score != null ? `${active.score.toFixed(1)} / 5` : '평가 없음'}</span>
          <span className={styles.barTooltipWeight}>가중치 {active.criterion.weight}%</span>
        </div>
      )}
    </div>
  );
}
